import HorizontalDividers from 'components/CustomDividers/HorizontalDividers';
import VerticalDividers from 'components/CustomDividers/VerticalDividers';
import { DialogContentStyled, Label, LeftContentWrapper, RightContentWrapper } from 'components/Dialog/DialogContent';
import { LeftContent } from 'components/Dialog/DialogLeftContent';
import { Bottom, BottomActions, RightForm } from 'components/Dialog/DialogRightContent';
import { ErrorMessage, Input, InputGrid } from 'components/Form';
import WarningIcon from '@mui/icons-material/Warning';
import React, { useEffect } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { getShopeeAuthorizeUrl } from 'api/marketPlaces';
import { channels } from 'shared/constants';
import { useAppStore } from 'stores/appStore';
import { AsyncButton } from 'components/ButtonNew/Button';
import ButtonReauthorization from 'pages/Onboarding/StepTwo/ButtonReauthorization';
import ButtonAuthorization from 'pages/Onboarding/StepTwo/ButtonAuthorization';

interface FormValues {
  store_name: string;
}

interface ShopeeConnectProps {
  chData?: {
    store_name: string;
  };
  isConnected?: boolean;
}

const ShopeeContent: React.FunctionComponent<ShopeeConnectProps> = ({ chData, isConnected = false }) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors }
  } = useForm<FormValues>();
  const { indexAccordion, disablePrevButton } = useAppStore();
  const [busy, setBusy] = React.useState<boolean>(false);

  const onSubmit: SubmitHandler<FormValues> = async () => {
    setBusy(true);
    const shopeeAuthorize = await getShopeeAuthorizeUrl(indexAccordion, disablePrevButton);
    const authorizeUrl = shopeeAuthorize.data.url;
    window.location.href = authorizeUrl;
    setBusy(false);
  };

  useEffect(() => {
    if (isConnected && chData?.store_name) {
      // Set the store name from the connected data
      setValue('store_name', chData.store_name);
    }
  }, [isConnected, chData, setValue]);

  return (
    <DialogContentStyled>
      <LeftContentWrapper>
        <LeftContent channelId={channels.SHOPEE} />
      </LeftContentWrapper>
      <VerticalDividers />
      <RightContentWrapper>
        <RightForm id="shopee_form" onSubmit={handleSubmit(onSubmit)}>
          <InputGrid
            label={<Label>Nama Toko</Label>}
            input={
              <Input
                isError={errors.store_name?.message ? true : false}
                type={'text'}
                placeholder={'Masukkan Nama Toko'}
                disabled={isConnected}
                {...register('store_name', {
                  required: { value: true, message: 'Nama Toko harus di isi' }
                })}
              />
            }
            errorMessage={
              errors?.store_name && (
                <ErrorMessage
                  icon={<WarningIcon fontSize="small" color="error" />}
                  message={errors.store_name.message}
                />
              )
            }
          />
        </RightForm>
        <Bottom>
          <HorizontalDividers />
          <BottomActions>
            <ButtonReauthorization {
              ...{
                isConnected,
                form: 'shopee_form'
              }
            } />
            <ButtonAuthorization {
              ...{
                form: 'shopee_form',
                disable: isConnected
              }
            } />
          </BottomActions>
        </Bottom>
      </RightContentWrapper>
    </DialogContentStyled>
  );
};

export default ShopeeContent;
